import React from 'react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
interface imageUrlDatatype {
    imageData: string;
    Mimetype:string;
    height?: string ; // Optional height prop
    width?: string ;  // Optional width prop
}
const AvatarImage: React.FC<imageUrlDatatype> = ({ imageData,Mimetype, height = '38px', width = '38px' }) => {
    return (
        imageData ?( <img style={{ height, width, borderRadius: "50%" }} src={`data:${Mimetype};base64,${imageData}`} alt="User Image"/> ): (<AccountCircleOutlinedIcon sx={{fontSize:height}} />)
    )
}

export default AvatarImage